import { useCallback, useState } from 'react'
import userInfoQuery from '@/providers/Auth/queries/userInfoQuery'
import { client as gqlClient } from '@/stackGqlClient'
import { UserRole } from '@/authProvider'
import Partner from '../types/Partner'
import Storage from '@/lib/Storage'
import { useRedirect } from 'react-admin'
import CONSTANTS from '@/constants'

const ON_SELECT_ROUTE = '/sales'
const PUBLISHER_TYPE = CONSTANTS.PARTNER_TYPE_PUBLISHER

export const useMultiRole = () => {
  const redirect = useRedirect()

  const [partners, setPartners] = useState<Partner[]>([])

  const fetchMultiRolePartners = useCallback(async () => {
    const { publishers, vendors, affiliates } = await userInfoQuery(gqlClient)
    const allPartners = publishers.concat(vendors, affiliates)

    setPartners(normalizePartners(allPartners))
  }, [])

  const selectPartner = useCallback(
    (partner: Partner) => {
      const subName = partner.company || partner.hostname || ''
      const type = partner?.type
      const role = {
        type,
        subname: subName,
        id: partner.id,
        name: partner.name,
        organizationId: partner.organization.databaseId
      }

      Storage().setActiveRole(role)
      redirect(ON_SELECT_ROUTE)
    },
    [redirect]
  )

  return {
    partners,
    fetchMultiRolePartners,
    selectPartner
  }
}

const normalizePartners = (partners: UserRole[]): Partner[] => {
  return partners.map((partner) => ({
    id: partner.id,
    name: partner.name,
    hostname: partner.type === PUBLISHER_TYPE ? partner.subname : undefined,
    company: partner.type !== PUBLISHER_TYPE ? partner.subname : undefined,
    organization: {
      databaseId: partner.organizationId
    },
    type: partner.type
  }))
}
